function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// lib/index.ts
import Color from "color";
import plugin from "tailwindcss/plugin";
import forEach from "lodash.foreach";
import flatten from "flat";
var SCHEME = Symbol("color-scheme");
var emptyConfig = {};

var resolveTwcConfig = function resolveTwcConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyConfig;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$produceCssVariab = _ref.produceCssVariable,
      produceCssVariable = _ref$produceCssVariab === void 0 ? defaultProduceCssVariable : _ref$produceCssVariab,
      _ref$produceThemeClas = _ref.produceThemeClass,
      produceThemeClass = _ref$produceThemeClas === void 0 ? defaultProduceThemeClass : _ref$produceThemeClas,
      _ref$produceThemeVari = _ref.produceThemeVariant,
      produceThemeVariant = _ref$produceThemeVari === void 0 ? produceThemeClass : _ref$produceThemeVari,
      defaultTheme = _ref.defaultTheme,
      _ref$strict = _ref.strict,
      strict = _ref$strict === void 0 ? false : _ref$strict;

  var resolved = {
    variants: [],
    utilities: {},
    colors: {}
  };
  var configObject = typeof config === "function" ? config({
    dark: dark,
    light: light
  }) : config;
  forEach(configObject, function (colors, themeName) {
    var themeClassName = produceThemeClass(themeName);
    var themeVariant = produceThemeVariant(themeName);
    var flatColors = flattenColors(colors);
    resolved.variants.push({
      name: themeVariant,
      // tailwind will generate only the first matched definition
      definition: [generateVariantDefinitions(".".concat(themeClassName)), generateVariantDefinitions("[data-theme='".concat(themeName, "']")), generateRootVariantDefinitions(themeName, defaultTheme)].flat()
    });
    var cssSelector = ".".concat(themeClassName, ",[data-theme=\"").concat(themeName, "\"]");
    resolved.utilities[cssSelector] = colors[SCHEME] ? {
      "color-scheme": colors[SCHEME]
    } : {};
    forEach(flatColors, function (colorValue, colorName) {
      if (colorName === SCHEME) return;
      var safeColorName = escapeChars(colorName, "/");
      var h = 0,
          s = 0,
          l = 0,
          defaultAlphaValue = 1;

      try {
        var _toHslaArray = toHslaArray(colorValue);

        var _toHslaArray2 = _slicedToArray(_toHslaArray, 4);

        h = _toHslaArray2[0];
        s = _toHslaArray2[1];
        l = _toHslaArray2[2];
        defaultAlphaValue = _toHslaArray2[3];
      } catch (error) {
        var message = "\r\nWarning - In theme \"".concat(themeName, "\" color \"").concat(colorName, "\". ").concat(error.message);

        if (strict) {
          throw new Error(message);
        }

        return console.error(message);
      }

      var twcColorVariable = produceCssVariable(safeColorName);
      var twcOpacityVariable = "".concat(produceCssVariable(safeColorName), "-opacity");
      var hslValues = "".concat(h, " ").concat(s, "% ").concat(l, "%");
      resolved.utilities[cssSelector][twcColorVariable] = hslValues;
      addRootUtilities(resolved.utilities, {
        key: twcColorVariable,
        value: hslValues,
        defaultTheme: defaultTheme,
        themeName: themeName
      });

      if (typeof defaultAlphaValue === "number") {
        var alphaValue = defaultAlphaValue.toFixed(2);
        resolved.utilities[cssSelector][twcOpacityVariable] = alphaValue;
        addRootUtilities(resolved.utilities, {
          key: twcOpacityVariable,
          value: alphaValue,
          defaultTheme: defaultTheme,
          themeName: themeName
        });
      }

      resolved.colors[colorName] = function (_ref2) {
        var opacityVariable = _ref2.opacityVariable,
            opacityValue = _ref2.opacityValue;

        if (!isNaN(+opacityValue)) {
          return "hsl(var(".concat(twcColorVariable, ") / ").concat(opacityValue, ")");
        }

        if (opacityVariable) {
          return "hsl(var(".concat(twcColorVariable, ") / var(").concat(twcOpacityVariable, ", var(").concat(opacityVariable, ")))");
        }

        return "hsl(var(".concat(twcColorVariable, ") / var(").concat(twcOpacityVariable, ", 1))");
      };
    });
  });
  return resolved;
};

var createThemes = function createThemes() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyConfig;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resolved = resolveTwcConfig(config, options);
  return plugin(function (_ref3) {
    var addUtilities = _ref3.addUtilities,
        addVariant = _ref3.addVariant;
    addUtilities(resolved.utilities);
    resolved.variants.forEach(function (_ref4) {
      var name = _ref4.name,
          definition = _ref4.definition;
      return addVariant(name, definition);
    });
  }, // extend the colors config
  {
    theme: {
      extend: {
        // @ts-ignore tailwind types are broken
        colors: resolved.colors
      }
    }
  });
};

function escapeChars(str) {
  var result = str;

  for (var _len = arguments.length, chars = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    chars[_key - 1] = arguments[_key];
  }

  for (var _i2 = 0, _chars = chars; _i2 < _chars.length; _i2++) {
    var char = _chars[_i2];
    var regexp = new RegExp(char, "g");
    result = str.replace(regexp, "\\" + char);
  }

  return result;
}

function flattenColors(colors) {
  var flatColorsWithDEFAULT = flatten(colors, {
    safe: true,
    delimiter: "-"
  });
  return Object.entries(flatColorsWithDEFAULT).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    acc[key.replace(/\-DEFAULT$/, "")] = value;
    return acc;
  }, {});
}

function toHslaArray(colorValue) {
  return Color(colorValue).hsl().round(1).array();
}

function defaultProduceCssVariable(themeName) {
  return "--twc-".concat(themeName);
}

function defaultProduceThemeClass(themeName) {
  return themeName;
}

function dark(colors) {
  return _objectSpread(_objectSpread({}, colors), {}, _defineProperty({}, SCHEME, "dark"));
}

function light(colors) {
  return _objectSpread(_objectSpread({}, colors), {}, _defineProperty({}, SCHEME, "light"));
}

function generateVariantDefinitions(selector) {
  return ["".concat(selector, "&"), ":is(".concat(selector, " > &:not([data-theme]))"), ":is(".concat(selector, " &:not(").concat(selector, " [data-theme]:not(").concat(selector, ") * ))"), ":is(".concat(selector, ":not(:has([data-theme])) &:not([data-theme]))")];
}

function generateRootVariantDefinitions(themeName, defaultTheme) {
  var baseDefinitions = [":root&", ":is(:root > &:not([data-theme]))", ":is(:root &:not([data-theme] *):not([data-theme]))"];

  if (typeof defaultTheme === "string" && themeName === defaultTheme) {
    return baseDefinitions;
  }

  if (_typeof(defaultTheme) === "object" && themeName === defaultTheme.light) {
    return baseDefinitions.map(function (definition) {
      return "@media (prefers-color-scheme: light){".concat(definition, "}");
    });
  }

  if (_typeof(defaultTheme) === "object" && themeName === defaultTheme.dark) {
    return baseDefinitions.map(function (definition) {
      return "@media (prefers-color-scheme: dark){".concat(definition, "}");
    });
  }

  return [];
}

function addRootUtilities(utilities, _ref7) {
  var key = _ref7.key,
      value = _ref7.value,
      defaultTheme = _ref7.defaultTheme,
      themeName = _ref7.themeName;
  if (!defaultTheme) return;

  if (typeof defaultTheme === "string") {
    if (themeName === defaultTheme) {
      if (!utilities[":root"]) {
        utilities[":root"] = {};
      }

      utilities[":root"][key] = value;
    }
  } else if (themeName === defaultTheme.light) {
    if (!utilities["@media (prefers-color-scheme: light)"]) {
      utilities["@media (prefers-color-scheme: light)"] = {
        ":root": {}
      };
    }

    utilities["@media (prefers-color-scheme: light)"][":root"][key] = value;
  } else if (themeName === defaultTheme.dark) {
    if (!utilities["@media (prefers-color-scheme: dark)"]) {
      utilities["@media (prefers-color-scheme: dark)"] = {
        ":root": {}
      };
    }

    utilities["@media (prefers-color-scheme: dark)"][":root"][key] = value;
  }
}

export { createThemes, resolveTwcConfig };